// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Signup_wrapper__3kZNM","textInput1":"Signup_textInput1__3UURw","textInput2":"Signup_textInput2__10LqJ","tabItem":"Signup_tabItem__1lf1V"};